import React from 'react';
import Modal from 'react-modal';
import i18next from 'i18next';

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '400px',
    width: '90%',
    borderRadius: '0.5rem',
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    padding: '1.5rem',
  },
};

const ConfirmModal = ({ isOpen, message, onConfirm, onCancel }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onCancel}
    style={modalStyles}
    overlayClassName="Overlay"
    contentLabel="confirm"
  >
    <p style={{ marginBottom: '1.5rem', textAlign: 'center' }}>{message}</p>
    <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
      <button onClick={onCancel}>{i18next.t('cancel')}</button>
      <button className='danger' onClick={onConfirm}>{i18next.t('confirm')}</button>
    </div>
  </Modal>
);

export default ConfirmModal;
